import React from "react";
import {
    ConnectionProvider,
    IntegrationConnection,
} from "@common/types/integrationConnection";
import { INTEGRATION_CONNECTIONS_SETTINGS } from "@common/helpers/integrationConnection";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Collapsible } from "@design-system/Collapsible/Collapsible";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { AlertIcon } from "@icons";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { CONNECTION_PROVIDER_INSTITUTIONS } from "@components/institution/resolveInstitutionIcon";
import { DisplayAccountingIntegration } from "../DisplayAccountingIntegration";
import css from "./ProviderIntegrationConnections.module.scss";

interface Props {
    integrationConnections: IntegrationConnection[];
    provider: ConnectionProvider;
}

export const AccountingIntegrationConnections: React.FC<Props> = ({
    integrationConnections,
    provider,
}) => {
    const settings = INTEGRATION_CONNECTIONS_SETTINGS[provider];

    const hasConnectionError = integrationConnections.some(
        (connection) => connection.error,
    );

    return (
        <Collapsible
            className={css.container}
            header={
                <div className={css.header}>
                    <InstitutionIcon
                        institution={CONNECTION_PROVIDER_INSTITUTIONS[provider]}
                        size="lg"
                    />
                    <main>
                        <h5>
                            {settings.label}
                            {hasConnectionError && (
                                <Tooltip content="One or more integrations are disconnected.">
                                    <span>
                                        <AlertIcon className="ml-2 icon-color-red-500" />
                                    </span>
                                </Tooltip>
                            )}
                        </h5>
                    </main>
                </div>
            }
        >
            <>
                {integrationConnections?.map((connection) => (
                    <DisplayAccountingIntegration
                        key={connection.id}
                        integrationConnection={connection}
                    />
                ))}
            </>
        </Collapsible>
    );
};
